import React, { useRef, useState } from 'react';
import './index.sass';
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation} from 'swiper';
import ProjectSlide from "./Project-Slide";
import {ReactComponent as ArrowLeft} from './icons/arrowLeft.svg';
import {ReactComponent as ArrowRight} from './icons/arrowRight.svg';
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss';

SwiperCore.use([Navigation]);

// Продукты экосистемы WSG (как в портфеле wsgfactory)
const data = [
    {
        title: 'Vanguard',
        code: 'VNG',
        color: 'green',
        description: 'Количественная оценка кибербезопасности по методике ФСТЭК. Защищённость системы в двух числах: показатель П для регулятора и себестоимость атаки в рублях — для совета директоров.',
        customer: 'Enterprise / регуляторы',
        technologies: ['ФСТЭК', 'Аудит', 'Аналитика', 'Отчётность'],
        payload: 'Количественная метрика',
        domain: 'Информационная безопасность',
        status: 'Продукт'
    },
    {
        title: 'Mercury',
        code: 'MRC',
        color: 'teal',
        description: 'Биллинг для телеком-операторов: путь от CDR до оплаченного счёта. Тарификация, онлайн-чарджинг и закрытие периодов по стандартам TM Forum.',
        customer: 'Телеком-операторы',
        technologies: ['Java', 'TM Forum', 'Онлайн-чарджинг', 'Тарификация'],
        payload: 'CDR → счёт',
        domain: 'Телеком / Финтех',
        status: 'Продукт'
    },
    {
        title: 'Agora',
        code: 'AGR',
        color: 'orange',
        description: 'E-commerce платформа и маркетплейс. Каталог и витрины товаров, корзина и оформление заказа, приём оплаты — полный контур онлайн-торговли от карточки товара до успешной покупки.',
        customer: 'E-commerce / ритейл',
        technologies: ['Каталог', 'Корзина', 'Заказы', 'Платежи', 'Маркетплейс'],
        payload: 'Онлайн-торговля',
        domain: 'E-commerce',
        status: 'Продукт'
    },
    {
        title: 'Vega',
        code: 'VEG',
        color: 'violet',
        description: 'Аналитика по фокусам и отношениям в организации. Превращает организационную структуру и связи в наглядные графы и метрики для принятия решений.',
        customer: 'Руководство / аналитика',
        technologies: ['Graph', 'Аналитика', 'Визуализация', 'Орг-структура'],
        payload: 'Графы отношений',
        domain: 'Аналитика',
        status: 'Продукт'
    },
    {
        title: 'Ecosystem WSG',
        code: 'ECO',
        color: 'red',
        description: 'Единая экосистема продуктов организации. Связывает отдельные продукты в цельную платформу с общим контуром пользователей, данных и управления.',
        customer: 'Крупный enterprise',
        technologies: ['Платформа', 'Интеграции', 'SSO', 'Оркестрация'],
        payload: 'Единый контур',
        domain: 'Экосистема',
        status: 'Продукт'
    },
]

const Projects = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [active, setActive] = useState(1);

    return (
        <section className="Projects" id="projects">
            <div className="container container--slim">
                <div className="Projects__Head">
                    <span className="Projects__Eyebrow">Продукты и платформы</span>
                    <h2 className="Projects__Title">
                        Наши <span className="Text-Accent">продукты</span> высокой степени зрелости
                    </h2>
                    <p className="Projects__Lead">
                        Каждое из этих решений — живой промышленный продукт: от идеи и архитектуры
                        до эксплуатации и развития. Не демо, а системы, которые работают в реальных экосистемах.
                    </p>
                </div>

                <div className="Projects__Toolbar">
                    <div className="Projects__Counter">
                        <span className="Projects__Counter-Current">{String(active).padStart(2, '0')}</span>
                        <span className="Projects__Counter-Sep">/</span>
                        <span className="Projects__Counter-Total">{String(data.length).padStart(2, '0')}</span>
                    </div>
                    <div className="Projects__Nav">
                        <button ref={prevRef} className="Projects__Nav-Btn Projects__Nav-Btn--Prev" aria-label="Предыдущий продукт" type="button">
                            <ArrowLeft />
                        </button>
                        <button ref={nextRef} className="Projects__Nav-Btn Projects__Nav-Btn--Next" aria-label="Следующий продукт" type="button">
                            <ArrowRight />
                        </button>
                    </div>
                </div>

                <div className="Projects__Box">
                    <Swiper
                        spaceBetween={50}
                        slidesPerView={1}
                        autoHeight={false}
                        className="Projects-Slider"
                        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
                        onBeforeInit={(swiper) => {
                            // привязка кастомных кнопок к инстансу
                            if (swiper.params.navigation) {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                            }
                        }}
                        onSlideChange={(swiper) => setActive(swiper.realIndex + 1)}
                    >
                        {
                            data.map((slide, index) => {
                                return (
                                    <SwiperSlide key={index.toString()}>
                                        <ProjectSlide slide={slide}/>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Projects;
